import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './fonts/indexFonts.css';
import App from './componets/App/App';
import store from "./store/store";
import { Provider } from "react-redux";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
